module.exports = "https://static.zego.com/_next/static/images/chevron-down-2554d6fbdb13fa026ee40f15256bd972.svg";